// frontend/src/pages/AdminLogin.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "../styles/Admin.css";

const API_BASE = process.env.REACT_APP_API_BASE || '';

export default function AdminLogin({ setUser }) {
  const nav = useNavigate();
  const [id, setId] = useState('');
  const [pw, setPw] = useState('');
  const [msg, setMsg] = useState('');

  async function onSubmit(e) {
    e.preventDefault();
    setMsg('');

    try {
      const res = await fetch(`${API_BASE}/api/login.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ id, pw }),
      });
      const data = await res.json();

      if (!res.ok) {
        setMsg(data?.error || 'Login failed');
        return;
      }

      setUser(data.user);

      if (data?.user?.role === 'admin') nav('/admin', { replace: true });
      else nav('/', { replace: true });
    } catch (err) {
      setMsg('Network error');
    }
  }

  return (
    <div className="sub-page-container login-page">
      <div className="login-inner">
        <header className="login-header">
          <p className="login-kicker">MANAGEMENT</p>
          <h2 className="login-title">ADMIN LOGIN</h2>
        </header>

        <section className="login-card">
          <form onSubmit={onSubmit} className="admin-form">
            <div className="input-group">
              <label>Identification</label>
              <input 
                value={id} 
                onChange={e => setId(e.target.value)} 
                placeholder="ID" 
                autoComplete="username" 
                required
              />
            </div>
            <div className="input-group">
              <label>Password</label>
              <input 
                value={pw} 
                onChange={e => setPw(e.target.value)} 
                placeholder="Password" 
                type="password" 
                autoComplete="current-password" 
                required
              />
            </div>
            
            {msg && <p className="login-error-msg">{msg}</p>}
            
            <button type="submit" className="admin-btn login-submit-btn">
              ENTER SYSTEM
            </button>
          </form>
        </section>
        
        <div className="login-footer">
          <button onClick={() => nav('/')} className="back-home-btn">← BACK TO HOME</button>
        </div>
      </div>
    </div>
  );
}